import React from 'react'
import HomeHeader from '../../components/HomeHeader'
import Footer from '../../components/Footer'
import MessageContent from './components/MessageContent'

const Message: React.FC = () => {
  return (
    <>
      <HomeHeader />
      <MessageContent />
      <Footer />
    </>
  )
}

export default Message
